<template>

    <div id="report-pending">

        <div class="py-6" v-if="loaded">

            <ReportJobIndex v-model="form" @exportReport="exportReport" v-if="form.indexHasResults()"></ReportJobIndex>
            <div class="no-results panel" v-else>
                <div class="p-10">
                    <div class="text-gray-200 my-6">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-20 w-20 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                    </div>

                    <h2 class="text-gray-600 font-medium text-2xl text-center">No Pending Reports</h2>

                     <p class="text-center mt-4 text-sm text-gray-500">
                        We could not find any pending reports, <a href="#" @click.prevent="showCompleteReports">show completed reports</a>.
                    </p>
                </div>
            </div>

        </div>
        <Loading message="Loading Pending Reports" v-else></Loading>

    </div>

</template>

<script>
import Loading from "../Support/Loading";
import {ReportJob} from "../../app/Report/ReportJob";
import ReportJobIndex from "./ReportJobIndex";
import {PermissionMixin} from "../../support/mixins";

export default {
    name: "ReportIndex",
    mixins: [PermissionMixin],
    components: {
        ReportJobIndex,
        Loading
    },
    data() {
        return {
            form: false,
            loaded: false,
        }
    },
    methods: {
        showCompleteReports() {
            this.$emit('showCompleteReports');
        },
        exportReport(uuid) {
            let vm = this;

            vm.form.exportReport(uuid).catch(error => vm.handleError(error));
        },
    },
    mounted() {
        let vm = this;

        new Promise(resolve => {
            vm.form = new ReportJob();

            vm.form.pendingIndex().then(r => {
                resolve(true);
            });
        }).then(r => {
            vm.loaded = r;
        })
    }
}
</script>
